import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { CancellationSurveyPage, Step } from 'features/cancellationSurvey'
import { subscriptionQueryOptions } from 'hooks/api/subscriptions'
import { useCallback, useEffect } from 'react'
import { z } from 'zod/v4'

export const cancelSchema = z.object({
  step: z.enum(['feedback', 'confirm']).default('feedback'),
})

export type CancelSearch = z.infer<typeof cancelSchema>

export const Route = createFileRoute('/_authenticated/workspaces/$subscriptionId/plan/cancel/')({
  component: Page,
  validateSearch: cancelSchema,
  loader: ({ context: { queryClient, buildRequest }, params: { subscriptionId } }) => {
    queryClient.prefetchQuery(subscriptionQueryOptions(buildRequest, subscriptionId, ['upcomingAmount']))
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Cancel Subscription'),
      },
    ],
  }),
})

function Page() {
  const { step } = Route.useSearch()
  const navigate = Route.useNavigate()

  // Edge-case: if the initial step is 'confirm', redirect to 'feedback'.
  useEffect(
    () => {
      if (step === 'confirm') {
        navigate({ search: { step: 'feedback' } })
      }
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const changeStep = useCallback(
    (newStep: Step) => {
      switch (newStep) {
        case Step.Feedback:
          navigate({ search: { step: 'feedback' } })
          break

        case Step.Confirmation:
          navigate({ search: { step: 'confirm' } })
          break
      }
    },
    [navigate]
  )

  const activeStep = step === 'feedback' ? Step.Feedback : Step.Confirmation

  return <CancellationSurveyPage activeStep={activeStep} changeStep={changeStep} />
}
